<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="users"
      :options.sync="options"
      :loading="loading"
      :totalData="totalRoles"
      :customTopActions="true"
      :bodyFilter="true"
      item-key="id"
      table-height="70vh"
    >
      <template v-slot:top>
        <div class="d-flex justify-end my-4 mr-6">
          <v-btn
            color="primary"
            class="mb-2 rounded-pill elevation-0"
            @click="addItem"
            :disabled="loading"
          >
          New Role
          </v-btn>

          <v-btn
            icon
            color="warning"
            class="mb-2 ml-2"
            @click="getData"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:body-prepend>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              label="Role Type"
              v-model="search.role_type"
              :items="itemsRoleType"
              item-text="text"
              item-value="value"
              @change="changeSelect"
              @input="search.role_type = $event ? $event : ''"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
        </tr>
      </template>
      <template v-slot:action="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-icon small class="mr-2" @click="viewItem(item)">
              mdi-eye
            </v-icon>
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </td>
      </template>
    </TableView>

    <v-dialog v-model="dialog" max-width="400px">
      <v-card>
        <v-form>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    label="Role Type"
                    v-model="editedItem.roleType"
                    :items="itemsRoleType"
                    item-text="text"
                    item-value="value"
                    :error-messages="roleTypeErrors"
                    @change="$v.editedItem.roleType.$touch()"
                    @blur="$v.editedItem.roleType.$touch()"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editedItem.role"
                    label="Role Name"
                    :error-messages="roleErrors"
                    @change="$v.editedItem.role.$touch()"
                    @blur="$v.editedItem.role.$touch()"
                    :disabled="view"
                  />
                </v-col>
                <v-col v-if="editedIndex == -1" cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editedItem.description"
                    label="Description"
                    :error-messages="descriptionErrors"
                    @change="$v.editedItem.description.$touch()"
                    @blur="$v.editedItem.description.$touch()"
                    :disabled="view"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="close">
              Cancel
            </v-btn>
            <v-btn
              v-if="!view"
              color="blue darken-1"
              text
              :loading="loading"
              :disabled="loading"
              @click="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this item?</v-card-title
        >
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="closeDelete"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteItemConfirm"
            >OK</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { dataRoleTypes } from '../../store/params';
import { date, showAlert } from '../../lib/helpers';
import { headers, editedItem, defaultItem, search } from '../../components/user-management/user-role/attributes';

export default {
  mixins: [validationMixin],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
  },
  validations: {
    editedItem: {
      role: {
        required,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.role == null ||
              this.errorValidation.role.length < 1)
          );
        },
      },
      description: {},
      roleType: {
        required,
      },
    },
  },
  data: () => ({
    search,
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers,
    editedIndex: -1,
    editedItem,
    defaultItem,
    selectedRow: '',
    itemsRoleType: dataRoleTypes,
  }),
  computed: {
    formTitle() {
      let role = '';
      if (this.editedIndex != -1) {
        if (this.editedIndex == -2) role = 'View Role ID';
        else role = 'Edit Role ID';
      } else role = 'New Role ID';
      return role;
    },
    flashErrorMessage() {
      return this.$store.state.rbac.role.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.rbac.role.flashError;
      },
      set() {
        this.$store.commit('rbac/role/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.rbac.role.errors;
    },
    loading() {
      return this.$store.state.rbac.role.loading;
    },
    users() {
      return this.$store.state.rbac.role.allRoles;
    },
    totalRoles() {
      return this.$store.state.rbac.role.totalRoles;
    },
    totalPage() {
      return this.$store.state.rbac.role.totalPage;
    },
    itemsRole() {
      return this.$store.state.rbac.allRole;
    },
    roleErrors() {
      const errors = [];
      if (!this.$v.editedItem.role.$dirty) {
        return errors;
      }
      if (!this.$v.editedItem.role.required)
        errors.push('Rolename is required.');
      if (!this.$v.editedItem.role.isUnique) {
        if (this.errorValidation != null && this.errorValidation.role != null) {
          this.errorValidation.role.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      return errors;
    },
    roleTypeErrors() {
      const errors = [];
      if (!this.$v.editedItem.description.$dirty) {
        return errors;
      }
      if (!this.$v.editedItem.roleType.required)
        errors.push('Role Type is required.');
      return errors;
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    dialogDelete(val) {
      if (!val) this.closeDelete();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'editedItem.role': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.role != null &&
            val != this.errorValidation.role
          ) {
            this.$store.commit('rbac/role/clearErrorVariable', 'role');
          }
        }
      },
    },

    show() {
      if (!this.show) {
        this.search.role = '';
        this.search.description = '';
        this.$nextTick(() => {
          this.getData();
        });
      }
    },
  },
  beforeDestroy() {
    this.clearSearch();
  },
  methods: {
    changeSelect(){
      this.options.page = 1;
      this.getData();
    },
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.role_type = '';
      this.search.role = '';
      this.search.description = '';
      this.getData();
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    getData() {
      this.$store.commit('rbac/role/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store.dispatch('rbac/role/fetchRoles', {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
      });
    },

    viewItem(item) {
      const id = encodeURIComponent(item.role);
      this.$router.push(`/rbac-role/${id}/view`);
      this.$store.commit('rbac/role/setDetailData', item);
    },

    editItem(item) {
      this.view = false;
      this.editedIndex = this.$store.state.rbac.role.allRoles.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.$store.state.rbac.role.allRoles.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await this.$store
        .dispatch('rbac/role/deleteRole', {
          date,
          role: this.editedItem.role,
        })
        .then((status) => {
          if (status) {
            this.closeDelete();
            showAlert(
              this.$store,
              'Delete role success !',
              'mdi-check-circle',
              'green'
            );
          } else {
            showAlert(
              this.$store,
              'Error on delete role !',
              'mdi-alert',
              'red'
            );
            this.closeDelete();
          }
        });
    },

    addItem() {
      this.dialog = true;
    },

    close() {
      this.resetUniqueValidation();
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('rbac/role/setFlashErrorMessage', '');
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    checkRole(item) {
      return item.id == this.editedItem.role.id;
    },

    resetUniqueValidation() {
      this.$store.commit('rbac/role/clearErrors');
    },

    async save() {
      this.$store.commit('rbac/role/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.editedIndex > -1) {
          await this.$store
            .dispatch('rbac/role/updateRole', {
              date,
              role: this.editedItem.role,
              description: this.editedItem.description,
              index: this.editedIndex,
            })
            .then((status) => {
              if (status) {
                this.close();
                showAlert(
                  this.$store,
                  'Update role success !',
                  'mdi-check-circle',
                  'green'
                );
              } else {
                showAlert(
                  this.$store,
                  'Error on update role !',
                  'mdi-alert',
                  'red'
                );
              }
            });
        } else {
          await this.$store
            .dispatch('rbac/role/createRole', {
              date,
              role: this.editedItem.role,
              role_type: this.editedItem.roleType,
              description: this.editedItem.description,
            })
            .then((status) => {
              if (status) {
                this.close();
                showAlert(
                  this.$store,
                  'Add role success !',
                  'mdi-check-circle',
                  'green'
                );
              } else {
                showAlert(
                  this.$store,
                  'Error on create role !',
                  'mdi-alert',
                  'red'
                );
              }
            });
        }
      }
    },

    exportItem() {},
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
